import React, { useState, useEffect } from 'react'
import Modal from '../_layouts/Modal'
import Button from '../_atoms/Button/index'
import { Textarea } from '~/lib/ui/textarea'

const CancelMeetingModal = ({
  open,
  meeting,
  onClose,
  onConfirm,
  defaultMessage,
}) => {
  const [cancelMessage, setCancelMessage] = useState('')

  useEffect(() => {
    if (meeting) {
      const firstName = meeting.candidate?.split(' ')[0] || ''
      setCancelMessage(
        defaultMessage ||
          `Hi ${firstName},\n\nI'm so sorry, but I need to cancel this meeting. I'd love to meet with you soon so please take a look at my calendar and schedule at your earliest convenience. Again, my sincere apologies, and I look forward to meeting with you a different day.`,
      )
    } else {
      setCancelMessage('')
    }
  }, [meeting, defaultMessage])

  const handleConfirm = (e) => {
    e.preventDefault()
    if (meeting) {
      onConfirm(meeting, cancelMessage)
    }
    setCancelMessage('')
    window.location.reload()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Cancel Meeting"
      size="sm"
      actions={[
        <Button key="cancel" variant="ghost" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="confirm"
          variant="solid"
          color="primary"
          type="submit"
          onClick={handleConfirm}
        >
          Confirm
        </Button>,
      ]}
    >
      <div>
        <p>
          Are you sure you want to cancel the{' '}
          <strong>{meeting?.service_request}</strong> with{' '}
          <strong>{meeting?.candidate}</strong>?
        </p>
        <label className="mb-2 mt-4 block text-sm font-medium">
          Please write a message to the candidate explaining the cancellation
          below before confirming.
        </label>
        <Textarea
          className="h-[425px]"
          value={cancelMessage}
          onChange={(e) => setCancelMessage(e.target.value)}
        />
      </div>
    </Modal>
  )
}

export default CancelMeetingModal
